module.exports = {"title":"Libre elección de los mejores profesionales, en cualquier momento y desde cualquier lugar","general":"Medicina general y familiar","pediatrics":"Pediatría","alert":"¡Recibe la receta en tu móvil!","hire-now-with-price":"Contratar por 12,95 euros/mes 2 adultos + 2 niños incluídos","more-info-btn":"Más información"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/pt/public/views/primesalud-medical-assistance.json
// module id = 637
// module chunks = 116